import { put } from 'typed-redux-saga';

import { nextGridPageAction, prevGridPageAction } from '../../../../../pages/call/features/goloom-video-grid';
import { countMetrika } from '../../../../helpers/metrika';
import { DTMF_COMMANDS } from './command-map';

export function* dtmfChangeGridPageSaga(fullCommand: string) {
    if (fullCommand === DTMF_COMMANDS.pagination.prevPage) {
        yield* put(prevGridPageAction());
        countMetrika('dtmf', 'grid', 'pagination', 'prev');
    }
    if (fullCommand === DTMF_COMMANDS.pagination.nextPage) {
        yield* put(nextGridPageAction());
        countMetrika('dtmf', 'grid', 'pagination', 'next');
    }
}
